import type { Theme } from "@mui/material/styles";

/**
 * Adaptive padding for footer control buttons (play/pause, volume, quality,
 * speed, pip, fullscreen): tighter under 450px, roomier from sm/md up so the
 * controls visibly grow on larger screens, matching the reference player.
 */
export function playerFooterControlPadding(theme: Theme) {
  return {
    padding: theme.spacing(0.75),
    "@media (max-width: 450px)": {
      padding: theme.spacing(0.625),
    },
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1.25),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(1.5),
    },
  };
}
